import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useCompanyUsers } from '../../hooks/use-company-users';
import type { CompanyUser, CompanyUsersFilters } from '../../models/company-users.model';

export interface CompanyUserFieldProps extends Omit<SelectProps<CompanyUser>, 'options'> {
  defaultFilters: CompanyUsersFilters & { searchParams?: { ids: string[] } };
  label?: string;
  errorMessage?: SelectFieldProps<CompanyUser>['errorMessage'];
  isInvalid?: boolean;
}

export const CompanyUserField: React.FC<CompanyUserFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = useCompanyUsers(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { name: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { name: search } })}
      isLoading={isLoading}
    />
  );
};
